// extracted by mini-css-extract-plugin
export default {"mm-faq-page":"KK_kRCp9KjADc9ADRuv8","section-title":"lgNckTEWPSGGht6amOYM"};